import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { ELoadingAnimation } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useLoadingAnimationSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.loadedThenPlay),
                value: ELoadingAnimation.LoadedThenPlay,
            },
            {
                label: intl.formatMessage(message.playWhileLoading),
                value: ELoadingAnimation.PlaywhileLoading,
            },
        ],
        [intl],
    )
}
